// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Vodf","image":"Header_image__1-Qf1","name":"Header_name__2JPFF","info":"Header_info__20C9t","infoRow":"Header_infoRow__31z7d"};